module.exports = __webpack_public_path__ + "static/media/ICON_LAFISE-01.86a280e0.svg";